import { UI_LOADING_END, UI_LOADING_START } from 'actions/Types';

export * from './attendees';
export * from './backgrounds';
export * from './banners';
export * from './knock';
export * from './meeting';
export * from './overlays';
export * from './presenters';
export * from './program';
export * from './sceneLayers';
export * from './sources';
export * from './stream';
export * from './tabs';
export * from './settings';
export * from './templates';
export * from './request';
export * from './recording';
export * from './activeStreams';
export * from './scene';
export * from './featureFlags';
export * from './session';

export const startUILoading = key => {
  return dispatch => {
    const action = {
      type: UI_LOADING_START,
      key
    };
    dispatch(action);
  };
};

export const stopUILoading = key => {
  return dispatch => {
    const action = {
      type: UI_LOADING_END,
      key
    };
    dispatch(action);
  };
};
